import React, { useState, useRef } from "react";
import { api } from "@/lib/api";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";

export function imgUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`;
}

export default function ImageUploader({ onUploaded, label = "Upload image", testid = "uploader", currentPath, onClear, square = false }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => ref.current?.click();

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data.path);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={upload} className="hidden" data-testid={`${testid}-input`} />
      {currentPath ? (
        <div className="relative border border-[#122E1C] bg-[#030A06] overflow-hidden" style={{ aspectRatio: square ? "1/1" : "16/9" }}>
          <img src={imgUrl(currentPath)} alt="" className="w-full h-full object-cover" data-testid={`${testid}-preview`} />
          <button type="button" onClick={onClear} className="absolute top-2 right-2 bg-[#030A06] border border-[#FF3B30] text-[#FF3B30] p-1 hover:bg-[#FF3B30]/20" data-testid={`${testid}-clear`}>
            <X className="w-3 h-3" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={pick}
          disabled={busy}
          data-testid={`${testid}-btn`}
          className="w-full border-2 border-dashed border-[#122E1C] hover:border-[#00E676] bg-[#030A06] p-6 text-center text-[#8A9F90] hover:text-[#00E676] transition-colors flex flex-col items-center gap-2"
          style={{ aspectRatio: square ? "1/1" : "16/9" }}
        >
          <Upload className="w-5 h-5" />
          <span className="text-xs uppercase tracking-widest font-mono-jb">{busy ? "Uploading…" : label}</span>
        </button>
      )}
    </div>
  );
}
